// !!! IF YOU CHANGE ANY OF THE EXISTING PROPERTIES HERE, !!!
// !!! STUFF WILL BREAK                                   !!!
var StaticElements;
(function (StaticElements) {
  StaticElements["Footer"] = "footer-section";
  StaticElements["Header"] = "header-section";
  StaticElements["Cookie"] = "cookie-section";
})(StaticElements || (StaticElements = {}));
export { StaticElements };